import { jsx as _jsx } from "react/jsx-runtime";
import BaseModal from "react-modal";
const Modal = ({ children, ...props }) => {
    return (_jsx(BaseModal, { overlayClassName: "fixed inset-0 bg-black/70 flex items-center justify-center z-50", className: "bg-zinc-800 z-30 relative min-w-[40rem]", ...props, children: children }));
};
export default Modal;
